import removeNotification from '../actions/removeNotification';
import NotificationToastProps from '../store/schema/NotificationToastProps';
import { handleNotification } from '../utils/notificationHandler';
import * as React from 'react';

export default abstract class BaseToast extends React.Component<NotificationToastProps, {}> {
    abstract render(): JSX.Element;

    protected onActionClick = (e: React.MouseEvent<unknown>) => {
        e.stopPropagation();
        handleNotification(this.props.notification);
    };

    protected onCancelClick = (e: React.MouseEvent<unknown>) => {
        e.stopPropagation();
        removeNotification(this.props.notification);
    };
}
